"use strict";

var ZRCUSTOM = window.ZRCUSTOM || {};

/*----------------------------------------------
 * $
 * commonly accessed jQuery elements
 --------------------------------------------*/
ZRCUSTOM.$ = {};

ZRCUSTOM.ui = {

  accessibleNav : function() {
    var $mobileNavToggle = $('#mobileNavIcon'),
        $firstNavElement = $('#q'),
        $mainContent = $('#websiteWrapper'),
        $mobileNavClose = $('#mobileNavClose'),
        $menuWrapper = $('#shopify-section-gl_mobile_menu');

    // Ensure the mobile menu is hidden on page load
    $menuWrapper.css('display', 'none');

    $mobileNavToggle.on('click', function(){
      if ($mobileNavToggle.attr('aria-expanded') ==='false') {

        // Set the mobile menu back to display inline block
        $menuWrapper.css('display', 'inline-block');

        // Update mobileNavToggle aria attribute
        $mobileNavToggle.attr('aria-expanded', 'true');

        // Ensure that focus is trapped within the navigation
        $mainContent.attr('aria-hidden', 'true');
        $('.sr-skip-link').attr('aria-hidden', 'true');

        // Move focus inside navigation
        $firstNavElement.focus();
      }
    });

    $mobileNavClose.on('click', function(){
      if ($mobileNavToggle.attr('aria-expanded') === 'true') {

        // Close the navigation
        $('.basel-close-side').click();

        // Un-trap focus
        $mainContent.attr('aria-hidden', 'false');

        // Update mobileNavToggle aria attribute
        $mobileNavToggle.attr('aria-expanded', 'false');

        // Return focus to the nav hamburger
        $mobileNavToggle.focus();

        // Make sure the nav is hidden again
        $menuWrapper.css('display', 'none');
      }
    });
  },

  zrHideMiniCart: function () {
    $( ".shopping-cart a" ).on( "click", function() {
      $('.cart-widget-side').addClass('displayBlock').focus();
    });

    $('.widget-close').on("click", function(){
      $('.cart-widget-side').removeClass('displayBlock');
    });

    $('.basel-close-side').on("click", function() {
      $('.cart-widget-side').removeClass('displayBlock');
    });


  },

zrTrapFocusMiniCart: function () {
    var allBackgroundElements = document.querySelectorAll('.backgroundElement, [tabindex="-1"]')
    var miniCartBtn = document.querySelector('.shopping-cart')
    var addToCartBtn = document.getElementById('shopify_add_to_cart')
    var viewCartBtn = document.querySelector('.cart-button')
    var checkoutBtn = document.querySelector('.checkout-button')
    var miniCart = document.getElementById('mini-cart')
    var closeBtn = document.querySelector('.widget-close')
    var overlay = document.querySelector('.basel-close-side')
    var empty = document.querySelector('.empty')

    document.addEventListener('keydown', (e) => {
        if (e.target === miniCartBtn || e.target === addToCartBtn) {
            if (e.keyCode === 13) {
                for (var element of allBackgroundElements) {
                    element.setAttribute('tabindex', "0")
                }
                closeBtn.focus()
                overlay.style.display = "block"
            }
          } else if (e.target === empty) {
              if (e.shiftKey && e.keyCode === 9) {
                 e.preventDefault()
              } else if (e.keyCode === 9) {
                 e.preventDefault();
                 closeBtn.focus()
              }
            } else if (e.target === viewCartBtn) {
              if (e.shiftKey && e.keyCode === 9) {
                  e.preventDefault()
              } else if (e.keyCode === 9) {
                e.preventDefault();
                checkoutBtn.focus()
            }
        } else if (e.target === checkoutBtn) {
            if (e.shiftKey && e.keyCode === 9) {
                e.preventDefault()
            } else if (e.keyCode === 9) {
                e.preventDefault();
                closeBtn.focus();
            }
        }
    });
  }
}


/*----------------------------------------------
 * init
 * Core javascript That will be initialized when
 * the page loads
 --------------------------------------------*/
ZRCUSTOM.init = function() {
  ZRCUSTOM.ui.accessibleNav();
  ZRCUSTOM.ui.zrHideMiniCart();
  ZRCUSTOM.ui.zrTrapFocusMiniCart();
};

jQuery(document).ready(function(){
  ZRCUSTOM.init();
});
